import { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import Actions from "../../../../components/Common/Actions";
import FilledButton from "../../../../components/Common/Buttons/FilledButton";
import CommonFilterModal from "../../../../components/Common/CommonFilterModal";
import DoctorsFilterOptions from "../../../../components/Common/CommonFilterOptions";
import NavBarTitles from "../../../../components/Common/TabBar";
import ListPageLayout from "../../../../components/Layout";
import Deletepopup from "../../../../components/Modal/Deletepopup";
import useDebouncedSearch from "../../../../components/Utils/hooks/useDebouncedSearch";
import useDeleteHandler from "../../../../components/Utils/hooks/useDeleteHandler";
import usePageChange from "../../../../components/Utils/hooks/usePageChange";
import usePaginatedData from "../../../../components/Utils/hooks/usePaginatedData";
import useSortHandler from "../../../../components/Utils/hooks/useSortHandler";
import axios from "axios";
import {
  PartneredPharmaciesBreadcrumbs,
  PartneredPharmaciesnavBarData,
  statuses,
} from "../../Utils/MasterConst";

const PharmacyStore = () => {
  const navigate = useNavigate();
  const addPharmacyStoreSize = {
    id: "addnewpost",
    onClick: () => navigate("/master-pharmacy-store-create"),
    style: { width: "240px" },
    label: "Add Pharmacy Store Size",
  };
  // Sorting
  const [sort, setSort] = useState("");
  const [sortName, setSortName] = useState("Newest First");
  const handleSortClick = useSortHandler(setSort, setSortName);

  // Search
  const [search, setSearch] = useState("");
  const debouncedSearch = useDebouncedSearch(setSearch, () =>
    setPagination((prev) => ({ ...prev, skip: 0, currentPage: 1 })),
  );

  // Filter states
  const [selectedValues, setSelectedValues] = useState({
    "Pharmacy Store Size": [],
    Status: [],
  });
  const [filteringKey, setFilteringKey] = useState([]);
  const [tempSelectedValues, setTempSelectedValues] = useState({
    "Pharmacy Store Size": [],
    Status: [],
  });

  const [selectedCategory, setSelectedCategory] = useState(
    "Pharmacy Store Size",
  );
  const [isFilterModalVisible, setIsFilterModalVisible] = useState(false);

  // Delete state
  const [deleteId, setDeleteId] = useState("");
  const [showDelete, setShowDelete] = useState(false);
  const [loader, setLoader] = useState(true);

  // Pagination
  const { records, totalCount, pagination, setPagination, fetchData } =
    usePaginatedData({
      apiUrl: `${process.env.REACT_APP_API_URL}pharmacy-store-size/list`,
      initialParams: {
        sort,
        searchText: search,
        selectedValues,
      },
    });

  const handlePageChange = usePageChange(pagination, setPagination);
  const handleDelete = useDeleteHandler(
    "pharmacy-store-size",
    fetchData,
    setShowDelete,
  );

  useEffect(() => {
    setLoader(true);
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pagination.skip, pagination.limit, selectedValues, sort, search]);

  useEffect(() => {
    (async () => {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}pharmacy-store-size/getarray`,
      );
      if (response?.data.length > 0) {
        setFilteringKey(response?.data);
      }
    })();
  }, []);

  const columns = [
    {
      title: "S.No",
      render: (text, record, index) =>
        Number(pagination.skip || 0) + (index + 1),
      key: "serial",
      width: 80,
      fixed: "left",
    },
    {
      title: "Pharmacy Store Size",
      width: 300,
      dataIndex: "type",
      key: "type",
    },
    {
      title: "Status",
      dataIndex: "active",
      width: 150,
      key: "active",
      render: (active) => (active ? "Verified" : "Not Verified"),
    },
    {
      title: "Actions",
      key: "actions",
      render: (_, record) => (
        <div className="d-flex align-items-center">
          <Actions
            isEdit={true}
            isDelete={true}
            isView={true}
            onClickView={() =>
              navigate(`/master-pharmacy-store-view/${record._id}`)
            }
            onClickDelete={() => {
              setDeleteId(record._id);
              setShowDelete(true);
            }}
            onClickEdit={() =>
              navigate(`/master-pharmacy-store-edit/${record._id}`)
            }
          />
        </div>
      ),
    },
  ];

  const dataSource = records.map((el) => ({ ...el, key: el._id }));

  const filters = {
    "Pharmacy Store Size": filteringKey,
    Status: statuses,
  };

  useEffect(() => {
    records && setTimeout(() => setLoader(false));
  }, [records]);

  return (
    <ListPageLayout
      breadcrumbs={
        <PartneredPharmaciesBreadcrumbs last="Pharmacy Store Size" />
      }
      addButton={<FilledButton props={addPharmacyStoreSize} />}
      titles={<NavBarTitles titles={PartneredPharmaciesnavBarData} />}
      filters={
        <DoctorsFilterOptions
          limit={pagination.limit}
          setLimit={(val) =>
            setPagination((prev) => ({
              ...prev,
              limit: val,
              skip: 0,
              currentPage: 1,
            }))
          }
          search={search}
          onChange={debouncedSearch}
          handleSortClick={handleSortClick}
          sortName={sortName}
          filter_records={() => {}}
          setFilterShow={() => setIsFilterModalVisible(true)}
        />
      }
      tableProps={{
        columns,
        dataSource,
      }}
      totalCount={totalCount}
      pagination={pagination}
      onPageChange={(selected) => handlePageChange({ selected })}
      loader={loader}
    >
      {/* Optional children like modals */}
      {showDelete && (
        <Deletepopup
          handleDelete={() => handleDelete(deleteId)}
          id={deleteId}
          handleClose={() => setShowDelete(false)}
        />
      )}

      <CommonFilterModal
        visible={isFilterModalVisible}
        onClose={() => setIsFilterModalVisible(false)}
        onApply={() => {
          setSelectedValues(tempSelectedValues);
          setIsFilterModalVisible(false);
          setPagination((prev) => ({ ...prev, skip: 0, currentPage: 1 }));
          // fetchData();
        }}
        onReset={() => {
          setTempSelectedValues({ "Pharmacy Store Size": [], Status: [] });
          setSelectedValues({ "Pharmacy Store Size": [], Status: [] });
          setPagination((prev) => ({ ...prev, skip: 0, currentPage: 1 }));
          fetchData();
        }}
        filters={filters}
        selectedCategory={selectedCategory}
        setSelectedCategory={setSelectedCategory}
        selectedValues={tempSelectedValues}
        setSelectedValues={setTempSelectedValues}
      />
    </ListPageLayout>
  );
};

export default PharmacyStore;
